import { JetView } from "webix-jet";

import SideBar from "../sidebar";

export default class SideMenu extends JetView {
	config() {
		return {
			view: "sidemenu",
			width: 300,
			position: "left",
			state: state => {
				state.left = this.Parent.left;
				state.top = this.Parent.top;
				state.height = this.Parent.height;
			},
			body: SideBar,
		};
	}
	init() {
		this.on(this.app, "top:navigation", () => {
			this.getRoot().hide();
		});
	}
	Show(box) {
		if (this.getRoot().isVisible()) return;

		this.Parent = box;
		this.webix.delay(() => this.getRoot().show());
	}
}
